<ng-content select="[popover-trigger]"></ng-content>
<div [id]="tooltipId()" [class]="'popover-content popover-' + placement()" popover="manual" role="tooltip">
  <div class="popover-animation tooltip-surface typography-small-regular">
    <ng-content></ng-content>
  </div>
</div>
